<!--
 * @Date: 2022-09-28 17:36:33
 * @LastEditors: shikexin shikexin0116@163.com
 * @LastEditTime: 2022-10-10 16:08:10
 * @description: description
-->
<template>
  <div :class="$style.partner">
    <div :class="$style.title">
      {{ info.title }}
    </div>

    <div :class="$style.tabBar">
      <ul :class="$style.tabsBox">
        <li
          v-for="tab in info.tabs"
          :key="tab.alias"
          :class="{ [$style.on]: cur == tab.id }"
          @mouseenter="onMouseEnter(tab)"
          @mouseleave="onMouseLeave"
        >
          <span>{{ tab.name }}</span>
        </li>
      </ul>
    </div>
    <div :class="$style.contentBox">
      <div
        :class="$style.itemBox"
        v-for="item in curModule.content"
        :key="item.id"
      >
        <div :class="$style.itemContent">{{ item.info }}</div>
        <div :class="$style.inscribeBox">
          <div :class="$style.itemline"></div>
          <div :class="$style.itemInscribe">{{ item.inscribe }}</div>
        </div>
      </div>
    </div>
    <div :class="$style.btn" @click="jump()">查看更多伙伴</div>
  </div>
</template>
<script>

export default {
  name: '',
  props: {
    info: Object
  },
  data () {
    return {
      cur: 1,
      timer: null,
      showCover: false
    }
  },
  computed: {
    curModule () {
      const find = this.info.tabs.find(item => item.id === this.cur)
      return find || {}
    },
    currentContent () {
      return this.curModule.content || {}
      // const find = this.info.modules.find(item => item.alias === this.cur)
      // return (find && find.content) || {}
    }
  },
  created () {
  },
  methods: {
    onMouseEnter (tab) {
      this.timer = setTimeout(() => {
        this.cur = tab.id
        this.showCover = true
        setTimeout(() => {
          this.showCover = false
        }, 200)
      }, 100)
    },
    onMouseLeave () {
      clearTimeout(this.timer)
      this.timer = null
      this.showCover = false
    },
    jump () {
      window.open('/partner')
    }
  }
}
</script>

<style lang="scss" module>
.partner {
  position: relative;
  padding-top: 50px;

  .title {
    height: 28px;
    margin-bottom: 24px;
    text-align: center;
    line-height: 28px;
    font-size: 20px;
    font-weight: 500;
    color: #404040;
  }

  .tabBar {
    position: relative;
    // padding: 22px 0;
    margin-bottom: 30px;
    padding-bottom: 12px;
    border-bottom: 1px solid #ededed;

    & > ul {
      display: flex;
      justify-content: space-between;
      padding: 0;
      margin: 0;

      & li {
        position: relative;
        // @extend %center;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 320px;
        line-height: 22px;
        font-size: 16px;
        font-weight: 400;
        // letter-spacing: 1px;
        color: #888888;
        cursor: pointer;

        &.on {
          color: #fa6400;
          font-weight: 500;

          &:after {
            content: "";
            position: absolute;
            bottom: -13px;
            left: 0;
            right: 0;
            width: 34px;
            height: 2px;
            margin: 0 auto;
            background: #fa6400;
            border-radius: 2px;
          }
        }

        &:first-child {
          & .icon {
            margin-right: 13px;
            font-size: 24px;
          }
        }
      }
    }
  }

  .contentBox {
    position: relative;
    display: flex;
    flex-direction: column;
    padding: 0 20px;
  }

  .itemBox {
    position: relative;
    box-sizing: border-box;
    margin-bottom: 21px;
    padding: 30px 16px;
    background: linear-gradient(163deg, #fff5e7 0%, #ffffff 100%);
    box-shadow: 0px 8px 32px 0px rgba(206, 211, 226, 0.24),
      inset 2px 2px 0px 0px #ffffff;
    border-radius: 6px;

    &:before {
      content: "";
      position: absolute;
      top: -7px;
      left: 16px;
      width: 30px;
      height: 25px;
      background: url("../../../assets/img/aboutus/pc/partner/partner-box-bg.png")
        no-repeat center;
      background-size: 100% 100%;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  .itemContent {
    margin-bottom: 20px;
    line-height: 26px;
    font-size: 14px;
    font-weight: 300;
    color: #404040;
  }

  .inscribeBox {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .itemline {
    height: 1px;
    width: 60px;
    margin-right: 8px;
    background: #979797;
  }

  .itemInscribe {
    height: 20px;
    margin-right: 10px;
    line-height: 20px;
    font-size: 14px;
    font-weight: 400;
    color: #888888;
  }

  .btn {
    width: 180px;
    height: 36px;
    margin: 30px auto 50px;
    background: linear-gradient(315deg, #ffd492 0%, #fa8919 100%);
    border-radius: 21px;
    line-height: 36px;
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    color: #ffffff;
  }
}
</style>
